export class TipoEstabelecimento {
    id: string;
    codigo: string;
    descricao: string;
    dataAtualizacao: string;
}

export class TipoAtividade {
    id: string;
    codigo: string;
    descricao: string;
    dataAtualizacao: string;
}
export class TipoComplexidade {
    id: string;
    codigo: string;
    descricao: string;
    dataAtualizacao: string;
}

export class Dsei {
    codigo: string;
    descricao: string;
    id: string;
}

export class Aldeia {
    codigo: string;
    descricao: string;
    id: string;
}

export class PoloBase {
    codigo: string;
    codigoIndicador: string;
    dataInativacao: string;
    descricao: string;
    id: string;
}

export class MotivoDesativacao {
    descricao: string;
    codigo: string;
}

export class TipoEntidadeAdministrativa {
    id: string;
    codigo: string;
    descricao: string;
    dataAtualizacao: string;
    ativo: string;
}

export class OrgaoEmissorProfissional {
    id: string;
    descricao: string;
}

export class CboProfissional {
    id: string;
    descricao: string;
    display: string;
    records?: string;

    constructor(obj) {
        this.id = obj.id;
        this.descricao = obj.descricao;
        this.display = obj.id + ' - ' + obj.descricao;
        this.records = obj.records;
    }
}

export class RegiaoSaude {
    id: string;
    nome: string;
}

export class CNES {
    "cnes": string;
    "cnpj": string;
    "cpf": string;
    "dataAtivacao": string;
    "dataDesativacao": string;
    "dataReativacao": string;
    "id": string;
    "municipio": {
        "codigo": string;
        "codigoUf": string;
        "latitude": string;
        "longitude": string;
        "nome": string;
        "siglaUf": string
    };
    "nomeEmpresarial": string;
    "nomeFantasia": string;
    "status": {
        "codigo": string;
        "descricao": string
    };
    "tipoGestao": {
        "codigo": string;
        "descricao": string;
    }
}

export class CNES_TIPO extends CNES {};

export class DistritoSanitario {
    id: string;
    nome: string;
}

export class RegiaoAdministrativa {
    id: string;
    nome: string;
}

export class Unidade {
    id: string;
    nome: string;
}

export class Profissional {
    "id": number;
    "profissionalSUS": {
        "cns": string;
        "codigo": string;
        "cpf": string;
        "nome": string;
        "nomeSocial"?: string;
    };
    "registrosOcupacoes": [
        {
            "cargaHorariaSemanal": number;
            "cbo": {
                "descricao": string;
                "id": string;
                "seAreaSaude": string;
            };
            "cnpjEmpregador": string;
            "conselhoClasse": {
                "ativo": boolean;
                "codigo": string;
                "descricao": string;
            };
            "formaContratacaoDetalhamento": {
                "codigo": string;
                "descricao": string;
                "formaContratacaoEmpregador": {
                    "codigo": string;
                    "descricao": string;
                    "formaContratacaoEstabelecimento": {
                        "codigo": string;
                        "descricao": string;
                    };
                    "id": number;
                };
                "id": number;
                "tipoCategoria": string;
            };
            "id": number;
            "naturezaJuridica": {
                "ativo": boolean;
                "codigo": string;
                "descricao": string;
                "movimentacao": string;
            },
            "registroConselho": string;
            "ufConselho": string;
        }
    ];
    "residente": boolean;
    "responsavelAdministrativo": boolean;
    "responsavelTecnico": boolean;
    nome?: string;
}

export class TipoEquipamento {
    codigo: string;
    codigoIndicador: string;
    dataInativacao: string;
    descricao: string;
    id: string;
}

export class NivelAtencao {
    codigo: string;
    dataInativacao: string;
    descricao: string;
    id: string;
    tipoPrograma: any;
}

export class LeitoDetalhamento {
    codigo: string;
    codigoIndicador: string;
    dataInativacao: string;
    descricao: string;
    id: string;
    tipoLeito: number;
}

export class TipoLeito {
    codigo: string;
    codigoIndicador: string;
    dataInativacao: string;
    descricao: string;
    id: string;
}

export class TipoInstalacao {
    codigo: string;
    codigoIndicador: string;
    dataInativacao: string;
    descricao: string;
    id: string;
}

export class Instalacao {
    codigo: string;
    dataAtualizacao: string;
    dataInativacao: string;
    descricao: string;
    id: string;
    subTipoInstalacao: string;
    tipoInstalacao: string;
}

export class SubtipoTipoInstalacao {
    codigo: string;
    descricao: string;
}

export class ConselhoClasse {
    dataAtualizacao: string;
    dataInativacao: string;
    descricao: string;
    id: string;
}

export class Convenio {
    ativo: any;
    codigo: string;
    dataAtualizacao: string;
    dataInativacao: string;
    descricao: string;
    id: string;
}

export class FormaAcesso {
    id: string;
    codigo: string;
    descricao: string;
    dataAtualizacao: number;
    ativo: string;
    dataInativacao: number;
}

export class GrupoAtividadePrimaria {
    codigo: string;
    conceito: string;
    dataAtualizacao: string;
    descricao: string;
    id: string;
}

export class AtividadePrimaria {
    codigo: string;
    grupo: GrupoAtividadePrimaria;
    conceito: string;
    dataAtualizacao: string;
    descricao: string;
    id: string;
}

export class GrupoAtividadeSecundaria {
    codigo: string;
    conceito: string;
    dataAtualizacao: string;
    descricao: string;
    id: string;
}


export class AtividadeSecundaria {
    codigo: string;
    grupo: GrupoAtividadePrimaria;
    conceito: string;
    dataAtualizacao: string;
    descricao: string;
    id: string;
}

export class TipoGestao {
    codigo: string;
    // conceito: string;
    // dataAtualizacao: string;
    descricao: string;
    // id: string;
}

export class TipoMarcacao {
    tipoMarcacao: string;
    descricao: string;
}

export class GrupoMarcacao {
    codigo: string;
    descricao: string;
    tipoHabilitacao: string;
}

export class SubGrupoMarcacao {
    codigo: string;
    descricao: string;
    tipoHabilitacao: string;
    tipoOrigem: string;
}

export class TipoServico {
    codigo: string;
    descricao: string;
}
